import { useGet } from '@ngt/forms';
import { useMemo } from 'react';
import { SWRConfiguration, SWRResponse } from 'swr';
import { TenantGetAsCollection, TenantGetAsCollectionResponse } from '../../api/dtos';

const getData = (response?: SWRResponse<TenantGetAsCollectionResponse, TenantGetAsCollectionResponse>) => {
    return response?.data?.tenants
}
const getError = (response?: SWRResponse<TenantGetAsCollectionResponse, TenantGetAsCollectionResponse>) => (response?.error ?? response?.data)?.responseStatus;
// const getAdditionalState = (response?: SWRResponse<ContractGetCollectionByLotIdResponse, ContractGetCollectionByLotIdResponse>) => ({});

const useTenants = (configuration?: SWRConfiguration<TenantGetAsCollectionResponse, TenantGetAsCollectionResponse>) => {
    
    const request = useMemo(() => {
        return () => {
            return new TenantGetAsCollection();
        };
    }, [])

    return useGet(request, { getData, getError }, configuration);
}

export default useTenants;